import React, { useMemo } from 'react';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import { useInsightsShorts } from 'staticQueries/insights-shorts';
import { replaceKeyword } from 'utils';
import { useTrans } from 'utils/localisation';

import * as styles from './InsightsShorts.module.scss';

export default function InsightsShorts({ filterByCategory, theme, activeTab, withCount }) {
  const t = useTrans(['article']);
  const shorts = useInsightsShorts();

  const filteredShorts = useMemo(() => {
    if (filterByCategory) {
      return shorts.filter(item =>
        item.categories?.some(category => category === filterByCategory),
      );
    }

    return shorts;
  }, [filterByCategory, shorts]);

  return (
    <>
      {withCount && (
        <p className={styles.title}>
          {replaceKeyword(t('allShorts'), 'count', filteredShorts?.length)}
        </p>
      )}
      <DesktopLayout items={filteredShorts} theme={theme} activeTab={activeTab} />
      <MobileLayout items={filteredShorts} theme={theme} />
    </>
  );
}
